@if (enableDocumentPanel$ | async) {
<rask-toggle-panel label="Dokument"
    [defaultExpanded]="false"
    [validationIcon]="icon$ | async">
    @if(kontrakt$ | async; as kontrakt) {
      <rask-tabs>
        @if (enableRundvirkeGrotTab$ | async) {
          <rask-tab label="Rundvirke/Grot">
            <rask-kontrakt-generera-rapport
                *raskPermitted="[{ role: 'RASK.Kopplanera', canView: false }]; merge: true"
              rapportTyp="Kontrakt"
                [entityId]="kontrakt.id">
            </rask-kontrakt-generera-rapport>
            <rask-kontrakt-generera-rapport
              rapportTyp="Kontrakt-karta"
              [entityId]="kontrakt.id">
            </rask-kontrakt-generera-rapport>
            <rask-kontrakt-generera-rapport
              *raskPermitted="[{ role: 'RASK.Kopplanera', canView: false }]; merge: true"
              rapportTyp="Kontrakt-vardeberakning"
              [entityId]="kontrakt.id">
            </rask-kontrakt-generera-rapport>
            @if (canGenerateMatbesked$ | async) {
            <rask-kontrakt-matbesked>
            </rask-kontrakt-matbesked>
            }
          </rask-tab>
        }
        @if(enableSkogsvardTab$ | async){
          <rask-tab label="Skogsvård">
            @if (canGenerateSkogsvardsKontrakt$ | async) {
              <rask-kontrakt-generera-rapport
                rapportTyp="SkogsvardsKontrakt"
                [entityId]="kontrakt.id">
              </rask-kontrakt-generera-rapport>
            }
            @if (canGenerateSkogsvardSammanstallning$ | async) {
              <rask-kontrakt-generera-rapport
                rapportTyp="Kontrakt-skogsvardsSammanstallning"
                [entityId]="kontrakt.id">
              </rask-kontrakt-generera-rapport>
            }
            @if(canGenerateSkogsvardsKarta$ | async){
              <rask-kontrakt-generera-rapport
                rapportTyp="Kontrakt-skogsvardsKarta"
                [entityId]="kontrakt.id">
              </rask-kontrakt-generera-rapport>
            }
          </rask-tab>
        }
      </rask-tabs>
    }
  </rask-toggle-panel>
}
